import { useMutation } from 'react-query';
import { submitRegisterResult } from 'apis/registerResult';

const useMutationSubmitRegisterResult = () => {
  const { mutateAsync, ...rest } = useMutation(submitRegisterResult);

  return {
    mutateAsync,
    ...rest,
  };
};

export default useMutationSubmitRegisterResult;
